import SecuredPage from './SecuredPage';

export default SecuredPage;
